import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { branding, domain } from '../../../common/text';

import * as emails from 'common/emails.json';

declare const GAMING: boolean;

const siteNames = Object.values(domain).map(x => x.toLowerCase())

@Component({
  selector: 'terms-conditions-page',
  styleUrls: ['./terms-conditions-page.component.scss'],
  templateUrl: './terms-conditions-page.component.pug'
})
export class TermsConditionsPage implements OnInit {
  public today: Date;
  public brand: string = branding[GAMING ? 'gaming' : 'pfm'];
  public email: string = emails.inquiries;
  public content: string = GAMING ? 'creative content' : 'movies'
  public sites: string = (GAMING ? [...siteNames].reverse() : [...siteNames]).join(', ')

  constructor(private titleService: Title, private route: ActivatedRoute) { }

  public ngOnInit() {
    this.titleService.setTitle(`${this.brand} - Terms and Conditions`);
    this.today = new Date();
  }
}
